export const MOBILE_MOCK_VALID_METHODS = [
  'save',
  'restore',
  'drawImage',
  'fillText',
  'strokeText',
  'scale',
  'rotate',
  'translate',
  'fill',
  'stroke',
  'beginPath',
  'moveTo',
  'closePath',
  'lineTo',
  'clip',
  'quadraticCurveTo',
  'bezierCurveTo',
  'arc',
  'arcTo',
  'rect',
  'fillRect',
  'strokeRect',
  'clearRect',
];

export const MOBILE_MOCK_VALID_PROPERTIES = [
  'fillStyle',
  'strokeStyle',
  'shadowColor',
  'shadowBlur',
  'shadowOffsetX',
  'shadowOffsetY',
  'lineCap',
  'lineWith',
  'lineJoin',
  'miterLimit',
  'font',
  'textAlign',
  'textBaseline',
  'globalAlpha',
  'globalCompositeOperation',
];
